import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "var(--app-font-family, Arial, Helvetica, sans-serif)",
    "& *": {
      fontFamily: "inherit",
    },
    position: "relative",
    isolation: "isolate",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: 360,
    height: "100%",
    boxSizing: "border-box",
    borderRadius: 0,
    backgroundColor: "var(--color-background-paper)",
    boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.35)",
    color: "var(--color-text-primary)",
    overflow: "hidden",
    transition:
      "background-color 0.4s ease, color 0.4s ease, border-color 0.4s ease",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      zIndex: 2,
      background:
        "linear-gradient(90deg, var(--color-primary-main), transparent 72%)",
      opacity: 0.85,
    },
  },
  vibrant: {
    backgroundColor: "color-mix(in srgb, var(--color-primary-main) 16%, #07090d)",
    backgroundImage:
      "radial-gradient(135% 58% at 0% 100%, color-mix(in srgb, var(--color-primary-main) 45%, transparent) 0%, transparent 60%), " +
      "radial-gradient(140% 60% at 100% 100%, color-mix(in srgb, var(--color-primary-main) 30%, transparent) 0%, transparent 62%), " +
      "linear-gradient(180deg, color-mix(in srgb, var(--color-primary-main) 8%, #03050a) 0%, color-mix(in srgb, var(--color-primary-main) 16%, #05080d) 42%, color-mix(in srgb, var(--color-primary-main) 26%, #070b11) 72%, color-mix(in srgb, var(--color-primary-main) 36%, #0a1016) 100%)",
    "--color-text-primary": "#E7EEEC",
    "--color-text-secondary": "rgba(231, 238, 236, 0.72)",
    "--color-primary-text": "color-mix(in srgb, var(--color-primary-main) 52%, #ffffff)",
    "--color-background-paper": "transparent",
    "--total_row_background": "rgba(255, 255, 255, 0.08)",
    "--total_row_boldbackground": "rgba(255, 255, 255, 0.14)",
  },
  scrollArea: {
    position: "relative",
    zIndex: 1,
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    padding: theme.spacing(1.5, 1.25),
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0,
      display: "none",
    },
  },
  header: {
    position: "relative",
    zIndex: 1,
    flexShrink: 0,
    "&::after": {
      content: '""',
      display: "block",
      height: 2,
      borderRadius: 999,
      background:
        "linear-gradient(90deg, var(--color-primary-main) 0%, var(--total_row_boldbackground) 35%, var(--total_row_boldbackground) 100%)",
      opacity: 0.9,
      marginTop: theme.spacing(0.75),
      marginLeft: theme.spacing(1.75),
      marginRight: theme.spacing(1.75),
    },
  },
  footer: {
    position: "relative",
    zIndex: 1,
    flexShrink: 0,
    padding: theme.spacing(0.75, 1.25, 1.25),
    borderTop: "1px solid var(--total_row_boldbackground)",
    boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.45)",
    backgroundColor: "var(--color-background-paper)",
    backdropFilter: "blur(16px) saturate(160%)",
    WebkitBackdropFilter: "blur(16px) saturate(160%)",
    backgroundImage:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, transparent 55%)",
  },
  themeFooterItem: {
    width: "100%",
    boxSizing: "border-box",
    padding: theme.spacing(1, 1.15),
    borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    border: "1px solid transparent",
    backgroundColor: "transparent",
    color: "var(--color-text-primary)",
    cursor: "pointer",
    transition:
      "background-color 180ms ease, color 180ms ease, border-color 180ms ease, transform 160ms ease",
    "& .MuiListItemIcon-root": {
      minWidth: 32,
      color: "var(--color-text-secondary)",
      transition: "color 180ms ease",
    },
    "& .MuiListItemText-root": {
      margin: 0,
    },
    "&:hover, &:focus-visible, &.Mui-focusVisible": {
      backgroundColor: "var(--total_row_background)",
      borderColor: "var(--total_row_boldbackground)",
      color: "var(--color-primary-text)",
      transform: "translateX(2px)",
      outline: "none",
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-text)",
      },
    },
    "&:focus-visible, &.Mui-focusVisible": {
      boxShadow:
        "0 0 0 2px color-mix(in srgb, var(--color-primary-main) 55%, transparent)",
    },
  },
  themeFooterText: {
    fontSize: "0.84375rem",
    fontWeight: 600,
    letterSpacing: 0.1,
  },
  pagesidebarClosebutton: {
    padding: theme.spacing(0.5, 0.75),
    boxSizing: "border-box",
    justifyContent: "center",
    width: "100%",
    // 64px = height of the top navbar — keeps the logo fully
    // below the navbar in both expanded and compact (rail) modes.
    [theme.breakpoints.up("sm")]: {
      marginTop: "64px",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "7%",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: "12%",
      right: "12%",
      bottom: theme.spacing(-1.25),
      height: 1,
    },
  },
  pagesidebarClosebuttonone: {
    visibility: "hidden",
  },
  sectionWrap: {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    "&:not(:last-child)": {
      marginBottom: theme.spacing(1.5),
    },
  },
  sectionDivider: {
    height: 2,
    borderRadius: 999,
    background:
      "linear-gradient(90deg, var(--color-primary-main) 0%, var(--total_row_boldbackground) 35%, var(--total_row_boldbackground) 100%)",
    marginBottom: theme.spacing(0.75),
    opacity: 0.9,
    maxHeight: 4,
    overflow: "hidden",
    transition:
      "max-height 240ms cubic-bezier(0.4, 0, 0.2, 1), opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), margin 240ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  layoutGroup: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    fontSize: "0.6875rem",
    fontWeight: 800,
    letterSpacing: 1.4,
    textTransform: "uppercase",
    color: "var(--color-primary-text)",
    padding: theme.spacing(0.1, 0.35, 0.25),
  },
  layoutlist: {
    width: "100%",
    boxSizing: "border-box",
    marginTop: theme.spacing(0.35),
    borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    transition:
      "background-color 180ms ease, border-color 180ms ease, color 180ms ease, box-shadow 180ms ease, transform 160ms ease",
    overflow: "hidden",
  },
  sectionLabelItem: {
    width: "100%",
    padding: 0,
    marginTop: theme.spacing(0.4),
    marginBottom: theme.spacing(0.4),
    maxHeight: 48,
    overflow: "hidden",
    transition:
      "max-height 240ms cubic-bezier(0.4, 0, 0.2, 1), opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), margin 240ms cubic-bezier(0.4, 0, 0.2, 1), padding 240ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  sectionLabelText: {
    margin: 0,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  sectionLabelButton: {
    cursor: "pointer",
    borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    transition: "background-color 180ms ease",
    "&:hover, &:focus-visible, &.Mui-focusVisible": {
      backgroundColor: "var(--total_row_background)",
      outline: "none",
    },
    "&:focus-visible, &.Mui-focusVisible": {
      boxShadow:
        "0 0 0 2px color-mix(in srgb, var(--color-primary-main) 55%, transparent)",
    },
  },
  sectionChevron: {
    marginLeft: "auto",
    marginRight: theme.spacing(1),
    fontSize: "1.125rem",
    color: "var(--color-primary-text)",
    flexShrink: 0,
    transition: "transform 240ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  sectionChevronCollapsed: {
    transform: "rotate(-90deg)",
  },
  clickableBtns: {
    position: "relative",
    width: "100%",
    boxSizing: "border-box",
    marginBottom: theme.spacing(0.6),
    padding: theme.spacing(1.05, 1.15, 1.05, 1.6),
    borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    border: "1px solid transparent",
    backgroundColor: "transparent",
    color: "var(--color-text-primary)",
    cursor: "pointer",
    transition:
      "padding 240ms cubic-bezier(0.4, 0, 0.2, 1), background-color 180ms ease, border-color 180ms ease, color 180ms ease",
    "& .MuiListItemText-root": {
      margin: 0,
      maxWidth: 200,
      overflow: "hidden",
      transition:
        "opacity 220ms cubic-bezier(0.4, 0, 0.2, 1), max-width 240ms cubic-bezier(0.4, 0, 0.2, 1)",
    },
    "& .MuiListItemText-primary": {
      fontSize: "0.84375rem",
      fontWeight: 600,
      lineHeight: 1.35,
      letterSpacing: 0.1,
    },
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: "50%",
      width: 3,
      height: 0,
      transform: "translateY(-50%)",
      borderRadius: 999,
      background: "var(--color-primary-main)",
      transition: "height 180ms ease",
    },
    "&:hover, &:focus-visible, &.Mui-focusVisible": {
      backgroundColor: "var(--total_row_background)",
      borderColor: "var(--total_row_boldbackground)",
      color: "var(--color-primary-text)",
      outline: "none",
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-text)",
        transform: "scale(1.1)",
      },
    },
    "&:hover::before, &:focus-visible::before, &.Mui-focusVisible::before": {
      height: "58%",
    },
    "&:focus-visible, &.Mui-focusVisible": {
      boxShadow:
        "0 0 0 2px color-mix(in srgb, var(--color-primary-main) 55%, transparent)",
    },
    "& .MuiListItemIcon-root": {
      minWidth: 32,
      color: "var(--color-text-secondary)",
      transition: "all 180ms ease",
    },
  },
  active: {
    transition:
      "background 240ms cubic-bezier(0.4, 0, 0.2, 1), background-image 240ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 240ms cubic-bezier(0.4, 0, 0.2, 1), transform 240ms cubic-bezier(0.4, 0, 0.2, 1), border-color 240ms cubic-bezier(0.4, 0, 0.2, 1)",
    color: "var(--color-primary-contrast)",
    background: "var(--color-primary-main)",
    backgroundImage:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0) 55%)",
    borderColor: "transparent",
    boxShadow:
      "0 6px 18px rgba(0, 0, 0, 0.22), inset 0 0 0 1px rgba(255, 255, 255, 0.08)",
    transform: "translateX(2px)",
    "& .MuiListItemText-primary": {
      fontWeight: 700,
    },
    "&::before": {
      height: "68%",
      background: "var(--color-primary-contrast)",
      opacity: 0.9,
    },
    "& .MuiListItemIcon-root": {
      color: "var(--color-primary-contrast) !important",
      filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.25))",
      opacity: 1,
      transform: "scale(1.05)",
    },
    "&:hover": {
      background: "var(--color-primary-main)",
      backgroundImage:
        "linear-gradient(135deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0) 55%)",
      borderColor: "transparent",
      color: "var(--color-primary-contrast)",
      filter: "brightness(1.06)",
      transform: "translateX(2px)",
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-contrast) !important",
      },
    },
    "&:hover::before": {
      height: "68%",
    },
  },
  footerDivider: {
    marginTop: theme.spacing(0.75),
    backgroundColor: "var(--total_row_boldbackground)",
  },
  emptyState: {
    padding: theme.spacing(2, 1),
    color: "var(--color-text-secondary)",
    fontSize: "0.8125rem",
  },
  noIconItem: {
    paddingLeft: `${theme.spacing(1)}px !important`,
  },
  disabledItemWrap: {
    display: "block",
    width: "100%",
    cursor: "not-allowed",
  },
  menuLockIcon: {
    fontSize: "1rem",
    flexShrink: 0,
    marginLeft: theme.spacing(0.75),
    color: "var(--color-text-secondary)",
  },
  compactMode: {
    "& $pagesidebarClosebutton": {
      padding: theme.spacing(1, 0),
    },
    "& $header::after": {
      marginLeft: `${theme.spacing(0.75)}px !important`,
      marginRight: `${theme.spacing(0.75)}px !important`,
    },
    "& .MuiListItemText-root": {
      opacity: 0,
      maxWidth: "0 !important",
      margin: "0 !important",
      padding: "0 !important",
      pointerEvents: "none",
    },
    "& $sectionLabelItem": {
      maxHeight: "26px !important",
      opacity: "1 !important",
      marginTop: `${theme.spacing(1)}px !important`,
      marginBottom: `${theme.spacing(0.25)}px !important`,
      justifyContent: "center !important",
      padding: "0 !important",
      cursor: "default !important",
      "& .MuiListItemText-root": {
        opacity: "1 !important",
        maxWidth: "none !important",
        margin: "0 !important",
        padding: "0 !important",
        display: "flex !important",
        justifyContent: "center !important",
      },
      "& $layoutGroup": {
        justifyContent: "center !important",
        fontSize: "0.75rem !important",
        fontWeight: "900 !important",
        letterSpacing: "0.5px !important",
        color: "var(--color-primary-text) !important",
      },
    },
    "& $sectionDivider": {
      maxHeight: "2px !important",
      opacity: "0.85 !important",
      marginTop: `${theme.spacing(0.5)}px !important`,
      marginBottom: `${theme.spacing(0.5)}px !important`,
    },
    // Let the circle's outer ring shadow bleed outside the tile boundary.
    "& $layoutlist": {
      overflow: "visible !important",
    },
    "& $clickableBtns": {
      height: "38px !important",
      padding: "0 !important",
      marginBottom: "1px !important",
      overflow: "visible !important",
      justifyContent: "center !important",
      alignItems: "center !important",
      "& .MuiListItemIcon-root": {
        minWidth: "0 !important",
        margin: "0 !important",
        justifyContent: "center !important",
        alignItems: "center !important",
      },
    },
    "& $themeFooterItem": {
      height: "38px !important",
      padding: "0 !important",
      justifyContent: "center !important",
      alignItems: "center !important",
      "& .MuiListItemIcon-root": {
        minWidth: "0 !important",
        margin: "0 !important",
        justifyContent: "center !important",
        alignItems: "center !important",
      },
    },
    "& $noIconItem": {
      paddingLeft: "0 !important",
    },
    "& $scrollArea": {
      paddingLeft: "0 !important",
      paddingRight: "0 !important",
      paddingTop: "4px !important",
    },
    "& $sectionWrap": {
      paddingLeft: "0 !important",
      paddingRight: "0 !important",
      "&:not(:last-child)": {
        marginBottom: `${theme.spacing(1.25)}px !important`,
      },
    },
    "& $active": {
      background: "transparent !important",
      backgroundImage: "none !important",
      boxShadow: "none !important",
      borderColor: "transparent !important",
      transform: "none !important",
      filter: "none !important",
      "&:hover": {
        background: "transparent !important",
        backgroundImage: "none !important",
        transform: "none !important",
        filter: "none !important",
      },
      "&::before": {
        display: "none !important",
      },
      "&:hover::before": {
        display: "none !important",
      },
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-text) !important",
        transform: "none !important",
        filter: "none !important",
        width: "38px !important",
        height: "38px !important",
        minWidth: "38px !important",
        borderRadius: "50% !important",
        background:
          "color-mix(in srgb, var(--color-primary-main) 16%, transparent) !important",
        boxShadow:
          "0 0 0 2px color-mix(in srgb, var(--color-primary-main) 55%, transparent) !important",
        display: "inline-flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
      },
    },
  },
}));
